import * as React from 'react';
import { Button } from '@/components/ui/Button';
import clsx from 'clsx';

interface RetrainEchoProps {
  onRetrain?: () => void;
}

export const RetrainEcho: React.FC<RetrainEchoProps> = ({ onRetrain }) => (
  <div className='mt-6 flex w-full flex-col gap-4'>
    <Button
      variant='purple-dark'
      onClick={onRetrain}
      className={clsx(
        'w-full',
        'p-2 font-sans text-16 font-bold uppercase leading-27 tracking-normal'
      )}
    >
      Retrain Echo
    </Button>

    <p
      className={clsx(
        'text-center font-jakarta text-16 font-bold leading-160 tracking-neg-2',
        'text-brand-800'
      )}
    >
      Upload more photos and videos that show the real you to make your echo even better.
    </p>
  </div>
);
